module.exports = __webpack_public_path__ + "img/partner-1.7d37821c.png";